import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TableMixin extends Vue {
  defaultOpenedDetails: string[] = [];

  detailKey = 'Id';

  fetchAction = '';

  loading = false;

  @Watch('$route', { immediate: true })
  routeChanged(newVal: any) {
    if (!this.fetchAction) {
      return;
    }
    const currentPage = parseInt(newVal.hash.replace(/#page/g, ''), 10) || 1;
    this.$store.dispatch(this.fetchAction, { currentPage });
  }

  closeAllOtherDetails(row: any) {
    const id = row[this.detailKey];
    if (id === undefined) {
      return;
    }
    this.defaultOpenedDetails = [id];
  }

  isDetailed(id: string) {
    return this.defaultOpenedDetails.includes(id);
  }
}
